import Vue from 'vue';
import Router from 'vue-router';
import store from './store';


 
Vue.use(Router);

const router = new Router({
    // 🎈 @mattia da scommentare quando in produzione, su goku altrimenti non funziona
    //mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: '/login',
            name: 'route-login',
            meta: {
                guest: true
            },
            component: () => import('./views/account/login/ViewLogin.vue'),
            
        },
        {
            path: '/',
            redirect:'/inheritance',
            name: 'route-index',
            component: () => import('./views/inheritance/List.vue'),
            meta: {
                auth: true,
                label:"Home"
            },
        },
        {
            path: '/dashboard',
            
            name: 'route-dashboard',
            component: () => import('./views/inheritance/Dashboard.vue'),
            meta: {
                auth: true,
                label: "Dashboard"
            },
        },
        {
            path: '/inheritance',
         
            name: 'route-inheritance',
            component: () => import('./views/inheritance/List.vue'),
            meta: {
                auth: true,
                label: "Home"
            },
        },
        {
            path: '/inheritance/create',
            name: 'route-create-inheritance',
            meta: {
                auth: true,
                label: "Inserimento nuova pratica"
            },
            component: () => import('./views/inheritance/Create.vue')
        },
        {
            path: '/inheritance/success',
            name: 'route-success-inheritance',
            meta: {
                auth: true,
                label: "Modulo inserito correttamente"
            },
            component: () => import('./views/inheritance/Success.vue')
        },
        {
            path: '/inheritance/:id',
            name: 'route-info-inheritance',
            meta: {
                auth: true,
                label: "Modifica pratica"
            },
            component: () => import('./views/inheritance/Information.vue')
        },
        {
            path: '/message/list',
            name: 'route-messages',
            meta: {
                auth: true,
                label: "Modifica messaggio"
            },
            component: () => import('./views/message/list.vue')
        },
        {
            path: '/message/save/:id?',
            name: 'route-message',
            meta: {
                auth: true,
                label: "Modifica messaggio"
            },
            component: () => import('./views/message/save.vue')
        },
        {
            path: '/flows',
            name: 'route-flows',
            meta: {
                auth: true
            },
            component: () => import('./views/admin/flow/index.vue')
        },
        {
            path: '/ts/export',

            name: 'route-ts-export',
            component: () => import('./views/ts/export.vue'),
            meta: {
                auth: true,
                label: "Export TS"
            },
        },
        {
            path: '/page/error',
            name: 'route-error',
            meta: {
                guest: true
            },
            component: () => import('./views/pages/ViewError.vue')
        }
    ]
});


router.beforeEach((to, from, next) => {
    var isuser = false;
    if (localStorage.getItem('nb-succ-api')) {
        if (!store.getters.isAuthenticated) {
            store.dispatch('autoLogin');

            for (var i = 0; i < store.state.user.roles.length; i++) {
                if (store.state.user.roles[i] == "user") {
                    isuser = true;
                    break;
                }
            }

        }

    }
   
   
    

    if (to.matched.some(record => record.meta.auth)) {
      
        if (!store.getters.isAuthenticated) {
            next({
                path: '/login',
                replace: true
            });
            return;
        }

        store.dispatch("verifyToken");



        if (to.name != "route-success-inheritance") {
            store.dispatch("clearInheritance");
        }
        if ((to.name == "route-index" || to.name == 'route-inheritance') && isuser ) {
            next({
                name: "route-create-inheritance",
                replace: true
            });

            return;
        }

        store.dispatch("inheritanceCheck");
    }
   
    next();
});

export default router;
